(() => {
  if (window.cglCartPaginationReady) return;
  window.cglCartPaginationReady = true;
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-recommendation-variant]')) return;
    const card = select.closest('.cgl-cart-suggestion');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    const form = select.closest('form');
    const variantId = form?.querySelector('input[name="id"]');
    const quantity = form?.querySelector('input[name="quantity"]');
    if (!(variantId instanceof HTMLInputElement)) return;
    const valid = Boolean(option.value && !option.disabled);
    variantId.value = valid ? option.value : '';
    const button = form.querySelector('button[name="add"]');
    if (button) button.disabled = !valid;
    const price = card.querySelector('[data-recommendation-price]');
    if (price) price.textContent = valid ? option.dataset.price || '' : '';
    if (!valid) return;
    card.dataset.recommendationSku = option.dataset.sku || '';
    const component = form.closest('product-form-component');
    if (component) component.dataset.productId = option.dataset.productId || '';
    if (quantity instanceof HTMLInputElement) quantity.value = option.dataset.quantity || '1';
    card.querySelectorAll('[data-recommendation-link]').forEach((link) => { link.href = option.dataset.url; });
    const image = card.querySelector('.cgl-cart-suggestion-image img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.title || '';
    }
    const buttonContainer = card.querySelector('add-to-cart-component');
    if (buttonContainer && option.dataset.image) buttonContainer.dataset.productVariantMedia = option.dataset.image;
    const error = card.querySelector('[ref="addToCartTextError"]');
    error?.classList.add('hidden');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const select = form.querySelector('[data-recommendation-variant]');
    if (!(select instanceof HTMLSelectElement)) return;
    const option = select.selectedOptions[0];
    const variantId = form.querySelector('input[name="id"]');
    if (!option?.value || option.disabled || variantId?.value !== option.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      select.reportValidity();
      select.focus();
    }
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-recommendation-direction]') : null;
    if (!button || button.disabled) return;
    const section = button.closest('.cgl-cart-suggestions');
    if (!section) return;
    const items = [...section.querySelectorAll('.cgl-cart-suggestion')];
    const pageSize = Number(section.dataset.pageSize) || 2;
    const pages = Math.ceil(items.length / pageSize);
    const page = Math.max(0, Math.min(pages - 1, Number(section.dataset.page || 0) + Number(button.dataset.recommendationDirection)));
    section.dataset.page = String(page);
    items.forEach((item, index) => { item.hidden = Math.floor(index / pageSize) !== page; });
    section.querySelector('[data-recommendation-direction="-1"]').disabled = page === 0;
    section.querySelector('[data-recommendation-direction="1"]').disabled = page === pages - 1;
    section.querySelector('.cgl-cart-pagination-status').textContent = (section.dataset.pageLabel || 'Page [page] of [pages]')
      .replace('[page]', String(page + 1)).replace('[pages]', String(pages));
  });
})();
